import { render, staticRenderFns } from "./ConfirmationOfInsurance.vue?vue&type=template&id=866a5be8&"
import script from "./ConfirmationOfInsurance.vue?vue&type=script&lang=ts&"
export * from "./ConfirmationOfInsurance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports